import {
  BENEFICIARIES,
  SEND_MONEY,
  VIRTUAL_ACCOUNTS,
} from "@zenith/routes/paths";

/** Pages that act on the main outlet's wallet, the same ones the sidebar shows only while it is in view. */
const MAIN_OUTLET_PATHS = [SEND_MONEY, BENEFICIARIES, VIRTUAL_ACCOUNTS];

export const requiresMainOutlet = (pathname: string): boolean =>
  MAIN_OUTLET_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
